module.exports = __webpack_public_path__ + "img/Butterfly_00287.697651b7.png";